/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Request6 { 
    dateFrom?: string;
    dateTo?: string;
    userIds?: Array<number>;
    storeIds?: Array<number>;
}

